const modals = {
  modalContainers: document.getElementsByClassName('modal-container'),
  modalCloseElements: document.getElementsByClassName('close-modal'),
  modalOpenElements: document.getElementsByClassName('open-modal'),
  modalTimers: [],

  init: function() {
    const _self = this;

    if (this.modalContainers.length) {

      for (const modal of this.modalContainers) {
        if ('#' + modal.dataset.modalId === window.location.hash) {
          this.openModal(modal.dataset.modalId);
        }

        if (modal.dataset.timer > 0) {
          this.setModalTimer(this.setModalTimer(modal.dataset.modalId, modal.dataset.timer));

          if (modal.classList.contains('show')) {
            document.body.classList.add('no-scroll');
          }
        }
      }

      for (const modalOpenElement of this.modalOpenElements) {
        modalOpenElement.addEventListener('click', function (e) {
          history.pushState({}, '', '#' + this.dataset.target);
          _self.openModal(this.dataset.target);
        });
      }

      for (const modalCloseElement of this.modalCloseElements) {
        modalCloseElement.addEventListener('click', function (e) {
          history.pushState({}, '', window.location.href.split('#')[0]);
          _self.closeModal(this.dataset.target);
        });
      }

      return true;
    } else return false;
  },

  openModal: function(modalId) {
    for (const modalContainer of this.modalContainers) {
      if (modalContainer.dataset.modalId === modalId) {
        modalContainer.classList.add('show');
        document.body.classList.add('no-scroll');
        break;
      }
    }
  },

  closeModal: function(modalId) {
    for (const modalContainer of this.modalContainers) {
      if (modalContainer.dataset.modalId === modalId) {
        modalContainer.classList.remove('show');
        document.body.classList.remove('no-scroll');
        break;
      }
    }
  },

  setModalTimer: function(modalId, time) {
    const _self = this;
    this.modalTimers.push(window.setTimeout(function() {_self.closeModal(modalId)}, time*1000));
  }
};

export default modals;
